import { getCaseAuthorities } from "./authorities"

export const readCase = defineAbility((user) => {
  const authorities = getCaseAuthorities(user)
  return authorities.includes("CASE_READ")
})

export const editCase = defineAbility((user) => {
  const authorities = getCaseAuthorities(user)
  return authorities.includes("CASE_EDIT")
})

export const createCase = defineAbility((user) => {
  const authorities = getCaseAuthorities(user)
  return authorities.includes("CASE_CREATE")
})

export const deleteCase = defineAbility((user) => {
  const authorities = getCaseAuthorities(user)
  return authorities.includes("CASE_DELETE")
})
